export enum WoundBedEnum {
  BeefyRed = 1,
  Yellow = 2,
  Pink = 3,
  Necrotic = 4,
  Other = 99
}

export const WoundBedOptions = [
{ id: 1, label: 'Beefy Red' },
{ id: 2, label: 'Yellow' },
{ id: 3, label: 'Pink' },
{ id: 4, label: 'Necrotic' },
{ id: 99, label: 'Other' }
];
